import {
  ScrollingMenu,
  ScrollingMenuItem,
} from "@components/backoffice/buttons/ScrollingMenu";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Divider, Grid, Popup, Icon } from "semantic-ui-react";
import { LoanUpdateDates } from "@pages/backoffice/Loan/LoanDetails/LoanUpdateDates";
import { OverdueLoanSendNotificationModal } from "@modules/Loan/backoffice/OverdueLoanSendNotificationModal";
import { ExtendModal } from "@pages/backoffice/Loan/LoanDetails/LoanActions/ExtendModal";
import { CancelLoanModal } from "@pages/backoffice/Loan/LoanDetails/LoanActions/CancelButton";
import { omit } from "lodash/object";
import _isEmpty from "lodash/isEmpty";

export default class LoanActionMenu extends Component {
  renderAvailableActions(pid, patronPid, documentPid, itemPid, actions = {}) {
    const { performLoanAction, isLoading, loan } = this.props;

    // omit checkout because it must done in one of the available items
    if (!itemPid) {
      actions = omit(actions, "checkout");
    }

    const actionComponents = [];

    Object.keys(actions).forEach((action) => {
      const cancelAction = (cancelReason = null) =>
        performLoanAction(actions[action], documentPid, patronPid, {
          cancelReason: cancelReason,
        });
      const loanAction = () =>
        performLoanAction(actions[action], documentPid, patronPid);

      if (action === "cancel") {
        actionComponents.push(
          <CancelLoanModal
            key={action}
            pid={pid}
            isLoading={isLoading}
            cancelAction={cancelAction}
          />
        );
      } else if (action === "extend") {
        actionComponents.push(
          <ExtendModal
            key={action}
            pid={pid}
            isLoading={isLoading}
            loanAction={loanAction}
            loanDetails={loan}
          />
        );
      }
    });

    // If we have both cancel and extend actions, align them horizontally
    if (actionComponents.length > 1) {
      return (
        <Grid>
          <Grid.Row>
            {actionComponents.map((component, index) => (
              <Grid.Column key={index} width={8}>
                {component}
              </Grid.Column>
            ))}
          </Grid.Row>
        </Grid>
      );
    }

    // If we only have one action, return it normally
    return actionComponents.length > 0 ? actionComponents[0] : null;
  }

  render() {
    const { loan, offset } = this.props;

    const { availableActions, pid } = loan;
    const { document_pid, item_pid, patron_pid } = loan.metadata;

    const hasActions = !_isEmpty(availableActions);
    const hasOverdueReminder = loan.metadata.is_overdue;

    const tooltipContent = (
      <div>
        <div style={{ fontWeight: "bold", marginBottom: "8px" }}>
          Loan Edit and Delete
        </div>
        <div>
          Loans cannot be deleted. You can manage the loans by using the actions
          available below. You can change the dates by clicking on the extend
          option.
        </div>
      </div>
    );

    return (
      <div className="bo-action-menu">
        <LoanUpdateDates loan={loan} />

        <Divider horizontal>
          Actions
          <Popup
            trigger={
              <Icon
                name="info circle"
                style={{ marginLeft: "8px", cursor: "pointer" }}
              />
            }
            content={tooltipContent}
            position="top left"
            size="small"
            inverted
          />
        </Divider>

        <div className="pb-default">
          {hasActions && (
            <div style={{ marginBottom: "1rem" }}>
              {this.renderAvailableActions(
                pid,
                patron_pid,
                document_pid,
                item_pid,
                availableActions
              )}
            </div>
          )}

          {hasOverdueReminder && (
            <div style={{ marginBottom: "1rem" }}>
              <OverdueLoanSendNotificationModal loan={loan} />
            </div>
          )}

          {!hasActions && !hasOverdueReminder && (
            <div
              style={{
                color: "#999",
                fontStyle: "italic",
                padding: "1rem 0",
                textAlign: "center",
              }}
            >
              No actions available. The loan can't be changed in its current
              state.
            </div>
          )}
        </div>

        <Divider horizontal>Navigation</Divider>
        <ScrollingMenu offset={offset}>
          <ScrollingMenuItem label="Loan" elementId="loan-metadata" />
          <ScrollingMenuItem label="Physical copy" elementId="current-item" />
          <ScrollingMenuItem
            label="Available physical copies"
            elementId="available-items"
          />
        </ScrollingMenu>
      </div>
    );
  }
}

LoanActionMenu.propTypes = {
  loan: PropTypes.object.isRequired,
  offset: PropTypes.number.isRequired,
  performLoanAction: PropTypes.func,
  isLoading: PropTypes.bool,
};

LoanActionMenu.defaultProps = {
  performLoanAction: () => {},
  isLoading: false,
};
